let locales = {
    parametersTemplates_name: 'Nombre',
    parametersTemplates_subject: 'Asunto',
    parametersTemplates_template: 'Plantilla',
};

export default locales;